import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appIdString]'
})
export class IdStringDirective {

  @Output() validatorIdString = new EventEmitter<boolean>();
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9\-]*$/);

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if (event.key) {
      const val = this.replaceString(event.srcElement.value);
      event.srcElement.value = val;
      const inp = event.key;
      if (this.regex.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    } else {
      return true;
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    const val = this.replaceString(event.srcElement.value);
    event.srcElement.value = val;
    if (event.srcElement.value) {
      const inp = event.srcElement.value;
      if (this.regex.test(inp)) {
        this.validatorIdString.emit(true);
        return true;
      } else {
        this.validatorIdString.emit(false);
        return false;
      }
    } else {
      this.validatorIdString.emit(true);
      return true;
    }
  }

  /**
   * Function to replace the repeated characters
   * @param value The string to replace
   * @returns The string with characters replaced
   */
  replaceString(value: string): string {
    return value.replace(/\-{2,}/g, '-');
  }

}
